// extracted by mini-css-extract-plugin
module.exports = {"oktaCallback":"OktaCallback_oktaCallback__1DfOF"};